import React from 'react'
import { Box } from '@mui/material'
import { MarkdownPreview } from '../../markdown/Markdown/MarkdownPreview'
import { decodeHtmlCharCode } from '../../../../../utils/html'
import { MarkdownType } from './types'

type MarkdownPreviewViewProps = {
  previewText: string
  markdownType: MarkdownType
}

export const MarkdownPreviewView = ({
  previewText,
  markdownType,
}: MarkdownPreviewViewProps) => (
  <Box
    className={'markdown-body'}
    sx={{
      padding: '0',
      overflow: 'scroll',
      width: '100%',
      height: '100%',
      flex: '1 1 0%',
    }}
  >
    <MarkdownPreview
      text={decodeHtmlCharCode(previewText)}
      markdownType={markdownType}
    />
  </Box>
)
